import React, { useState, useRef } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Typography,
    Slide,
    Paper,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from '@iconify/react/dist/iconify.js';
import { ErrorMessage, Formik, Form } from 'formik';
import { addCountriesValidation } from '../../../../validationSchema/SocietyController/Location/locationSchema';
import { useDispatch } from 'react-redux';
import { createCountry } from '../../../../redux/actions/SocietyController/CtrlLocationAction/CtrlLocationAction';
import { useSelector } from 'react-redux';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const AddCountryModal = ({ open, handleClose, getCountryTableData = () => { }, editData = null, getTableData = () => { } }) => {

    // eslint-disable-next-line no-unused-vars
    const [_isSubmitting, _setIsSubmitting] = useState(false);
    const formRef = useRef(null);
    const dispatch = useDispatch()
    const { createLoading } = useSelector(state => state.CtrlLocationReducers)

    const handleSaveClick = () => {
        // Trigger form submission via ref
        formRef.current?.handleSubmit();
    }

    return (


        <Formik
            initialValues={{
                name: '',
                iso_code: '',
                iso_code_2: '',
                phone_code: '',
                currency: '',
            }}
            enableReinitialize
            validationSchema={addCountriesValidation()}
            onSubmit={(values, { resetForm, setSubmitting }) => {
                console.log(values, 'fasd')
                dispatch(createCountry({
                    ...values,
                    onSuccess: () => {
                        getCountryTableData()
                        handleClose();
                        resetForm();
                    }
                }));
                setSubmitting(false);
            }}
            innerRef={(f) => (formRef.current = f)}
        >
            {(formik) => {
                return (
                    <Form >

                        <Dialog
                            open={open}
                            onClose={handleClose}
                            TransitionComponent={Transition}
                            maxWidth="sm"
                            fullWidth
                            PaperProps={{
                                sx: {
                                    borderRadius: 3,
                                    overflow: 'hidden',
                                }
                            }}
                        >
                            {/* Header with Gradient Background */}
                            <Box
                                sx={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white',
                                    position: 'relative',
                                }}
                            >
                                {/* Background Pattern */}
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        opacity: 0.1,
                                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                                    }}
                                />

                                <DialogTitle sx={{ p: 2.5, pb: 2 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <Box
                                                sx={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: 2,
                                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <Icon icon="mdi:earth" width={24} height={24} />
                                            </Box>
                                            <Box>
                                                <Typography variant="h6" sx={{ fontWeight: 600, color: 'white', fontSize: '1.1rem' }}>
                                                    {editData ? 'Edit Country' : 'Add New Country'}
                                                </Typography>
                                                <p className='tw-text-sm tw-text-white'>
                                                    {editData ? 'Update country information' : 'Add a new country to the system'}
                                                </p>
                                            </Box>
                                        </Box>
                                        <IconButton
                                            aria-label="close"
                                            onClick={handleClose}
                                            size="small"
                                            sx={{
                                                color: 'white',
                                                backgroundColor: 'rgba(255,255,255,0.15)',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(255,255,255,0.25)',
                                                },
                                            }}
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </DialogTitle>
                            </Box>

                            <DialogContent sx={{ p: 0, bgcolor: '#f8fafc' }}>
                                <Box sx={{ p: 2.5 }}>
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            p: 2.5,
                                            borderRadius: 2,
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            backgroundColor: 'background.paper',
                                        }}
                                    >
                                        {/* Country Name */}
                                        <Box sx={{ mb: 2.5 }}>
                                            <Typography
                                                variant="body2"
                                                sx={{ fontWeight: 600, color: 'text.secondary', mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}
                                            >
                                                <Icon icon="mdi:earth" width={16} />
                                                Country Name <span style={{ color: '#ef4444' }}>*</span>
                                            </Typography>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formik.values.name}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                className="form-control radius-8"
                                                placeholder="Enter country name"
                                                style={{ fontSize: '0.875rem' }}
                                            />
                                            <div
                                                className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}
                                            >
                                                <ErrorMessage name="name" />
                                            </div>
                                        </Box>

                                        {/* Abbreviation & Mobile Code Row */}
                                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 2.5 }}>
                                            <Box>
                                                <Typography
                                                    variant="body2"
                                                    sx={{ fontWeight: 600, color: 'text.secondary', mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}
                                                >
                                                    <Icon icon="mdi:alphabetical" width={16} />
                                                    ISO <span style={{ color: '#ef4444' }}>*</span>
                                                </Typography>
                                                <input
                                                    type="text"
                                                    name="iso_code"
                                                    value={formik.values.iso_code}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    className="form-control radius-8"
                                                    placeholder="e.g., USA, GBR, IND"

                                                    maxLength={5}
                                                    style={{ fontSize: '0.875rem', textTransform: 'uppercase' }}
                                                />
                                                <div className="text-danger text-sm italic h-4 text-wrap break-words">
                                                    <ErrorMessage name="iso_code" />
                                                </div>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    variant="body2"
                                                    sx={{ fontWeight: 600, color: 'text.secondary', mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}
                                                >
                                                    <Icon icon="mdi:alphabetical" width={16} />
                                                    ISO 2<span style={{ color: '#ef4444' }}>*</span>
                                                </Typography>
                                                <input
                                                    type="text"
                                                    name="iso_code_2"
                                                    value={formik.values.iso_code_2}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    className="form-control radius-8"
                                                    placeholder="e.g., US, UK, IN"

                                                    maxLength={5}
                                                    style={{ fontSize: '0.875rem', textTransform: 'uppercase' }}
                                                />
                                                <div className="text-danger text-sm italic h-4 text-wrap break-words">
                                                    <ErrorMessage name="iso_code_2" />
                                                </div>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    variant="body2"
                                                    sx={{ fontWeight: 600, color: 'text.secondary', mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}
                                                >
                                                    <Icon icon="mdi:phone" width={16} />
                                                    Mobile Code
                                                </Typography>
                                                <input
                                                    type="text"
                                                    name="phone_code"
                                                    value={formik.values.phone_code}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    className="form-control radius-8"
                                                    placeholder="e.g., 91, 1, 44"
                                                    style={{ fontSize: '0.875rem' }}
                                                />
                                                <div className="text-danger text-sm italic h-4 text-wrap break-words">
                                                    <ErrorMessage name="phone_code" />
                                                </div>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    variant="body2"
                                                    sx={{ fontWeight: 600, color: 'text.secondary', mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}
                                                >
                                                    <Icon icon="mdi:currency-usd" width={16} />
                                                    Currency <span style={{ color: '#ef4444' }}>*</span>
                                                </Typography>
                                                <input
                                                    type="text"
                                                    name="currency"
                                                    value={formik.values.currency}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    className="form-control radius-8"
                                                    placeholder="e.g. INR, USD, EUR"
                                                    maxLength={3}
                                                    style={{ fontSize: '0.875rem' }}
                                                />
                                                <div className="text-danger text-sm italic h-4 text-wrap break-words">
                                                    <ErrorMessage name="currency" />
                                                </div>
                                            </Box>
                                        </Box>

                                        {/* Status */}
                                        {/* <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                p: 2,
                                                borderRadius: 2,
                                                backgroundColor: formData.status ? '#f0fdf4' : '#fef2f2',
                                                border: '1px solid',
                                                borderColor: formData.status ? '#bbf7d0' : '#fecaca',
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                <Icon
                                                    icon={formData.status ? "mdi:check-circle" : "mdi:close-circle"}
                                                    width={24}
                                                    style={{ color: formData.status ? '#22c55e' : '#ef4444' }}
                                                />
                                                <Box>
                                                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}>
                                                        Status
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                        {formData.status ? 'Country is active and visible' : 'Country is inactive and hidden'}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <div className="form-switch">
                                                <input
                                                    type="checkbox"
                                                    name="status"
                                                    checked={formData.status}
                                                    onChange={handleChange}
                                                    className="form-check-input"
                                                    id="countryStatus"
                                                    style={{ width: '44px', height: '24px', cursor: 'pointer' }}
                                                />
                                            </div>
                                        </Box> */}
                                    </Paper>
                                </Box>
                            </DialogContent>

                            {/* Actions */}
                            <DialogActions sx={{ px: 2.5, py: 2, borderTop: '1px solid', borderColor: 'divider', gap: 1.5, bgcolor: 'white' }}>
                                <button
                                    type="button"
                                    onClick={handleClose}
                                    className="btn btn-outline-secondary radius-8 px-20 py-10 text-sm fw-medium"
                                    disabled={createLoading}
                                    style={{ flex: 1 }}
                                >
                                    <Icon width="1.1rem" icon="solar:close-circle-outline" className="me-6" />
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary-600 radius-8 px-20 py-10 text-sm fw-medium"
                                    disabled={createLoading}
                                    onClick={handleSaveClick}
                                    style={{ flex: 1 }}
                                >
                                    {createLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-8" role="status" aria-hidden="true"></span>
                                            Saving...
                                        </>
                                    ) : (
                                        <>
                                            <Icon icon="solar:check-circle-bold" width="1.1rem" className="me-6" />
                                            {editData ? 'Update Country' : 'Save Country'}
                                        </>
                                    )}
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Form>
                )
            }}
        </Formik >


    );
};

export default AddCountryModal;
